import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent {
  title = 'NextGen MVP';

  constructor(){
    window["pageData"].page = {
      'htmlPageTitle': document.title
    };
  }
}

